// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a46f9f44","112":"011fecc8","453":"e70e7fdf","455":"8e686f82","461":"b3286919","492":"cef0a6d1","526":"e93f043e","694":"e2109c53","718":"d52dfc36","864":"96d43241","885":"7440d62f","931":"66703efc","977":"77f0bcbf"}[chunkId] + ".chunk.js";
};